import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 24 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: [0.2, 0.8, 0.2, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false, testId }) => (
  <p data-testid={testId} className={`mb-4 inline-flex items-center gap-2 t-label ${light ? "text-gold" : "text-leaf"}`}>
    <span className={`h-px w-8 ${light ? "bg-gold" : "bg-leaf"}`} />
    {children}
  </p>
);

export const SectionTitle = ({ children, light = false, className = "", testId }) => (
  <h2 data-testid={testId} className={`t-h2 max-w-3xl ${light ? "text-bone" : "text-forest"} ${className}`}>
    {children}
  </h2>
);
